/* Análisis web 2026-10 (Clarity): mejoras de conversión en ficha de producto, landing y Pack Newborn. */
(() => {
  "use strict";

  const mobile = window.matchMedia("(max-width: 767px)");
  const formatPrice = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? `€${number.toFixed(2).replace(".", ",")}` : "";
  };

  /* Galería deslizable con puntos: reutiliza las miniaturas existentes, que ya cambian con cada color. */
  const setupSwipeGallery = (gallery) => {
    const thumbsRoot = gallery.querySelector(".product-gallery__thumbs");
    const main = gallery.querySelector(".product-gallery__main");
    if (!thumbsRoot || !main) return;

    const dots = document.createElement("div");
    dots.className = "gallery-dots";
    dots.setAttribute("aria-label", "Imágenes del producto");
    gallery.append(dots);

    const thumbs = () => [...thumbsRoot.querySelectorAll("[data-gallery-thumb]")];
    const activeIndex = () => Math.max(0, thumbs().findIndex((thumb) => thumb.classList.contains("is-active")));
    const go = (index) => {
      const list = thumbs();
      if (!list.length) return;
      list[(index + list.length) % list.length].click();
    };

    const render = () => {
      const list = thumbs();
      const current = activeIndex();
      dots.hidden = list.length < 2;
      dots.replaceChildren(...list.map((_thumb, index) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", `Ver imagen ${index + 1} de ${list.length}`);
        dot.classList.toggle("is-active", index === current);
        if (index === current) dot.setAttribute("aria-current", "true");
        dot.addEventListener("click", () => go(index));
        return dot;
      }));
    };

    new MutationObserver(render).observe(thumbsRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    render();

    let start = null;
    main.addEventListener("touchstart", (event) => {
      const touch = event.touches[0];
      start = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });
    main.addEventListener("touchend", (event) => {
      if (!start || !mobile.matches) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      start = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(activeIndex() + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };

  /* Barra fija: miniatura, color y precio + "Comprar ahora" como enlace secundario. */
  const setupPurchaseCard = (card) => {
    const actions = card.querySelector(".purchase-card__actions");
    const addButton = card.querySelector(".purchase-card__actions [data-cart-add]:not([data-cart-mode])");
    const buyNow = card.querySelector(".purchase-card__actions .button--buy-now");
    const proxy = card.querySelector("[data-buy-now-proxy]");
    if (!actions || !addButton) return;

    const summary = document.createElement("div");
    summary.className = "buybar-summary";
    summary.innerHTML = '<img alt="" width="40" height="40"><span><b></b><strong></strong></span>';
    actions.prepend(summary);

    const sync = () => {
      const image = summary.querySelector("img");
      if (addButton.dataset.cartImage && image.src !== addButton.dataset.cartImage) image.src = addButton.dataset.cartImage;
      summary.querySelector("b").textContent = addButton.dataset.cartColor || "";
      summary.querySelector("strong").textContent = formatPrice(addButton.dataset.cartPrice);
      summary.hidden = addButton.hidden;
      if (proxy) proxy.hidden = !buyNow || buyNow.hidden;
    };

    const observer = new MutationObserver(sync);
    observer.observe(addButton, { attributes: true });
    if (buyNow) observer.observe(buyNow, { attributes: true, attributeFilter: ["hidden"] });
    sync();

    proxy?.addEventListener("click", () => buyNow?.click());
  };

  /* Si el color seleccionado está agotado (y no se pidió por URL), elegir uno disponible. */
  const preferAvailableOption = () => {
    if (new URLSearchParams(location.search).has("color")) return;
    const active = document.querySelector("[data-product-option].is-active");
    if (!active?.classList.contains("is-unavailable")) return;
    document.querySelector("[data-product-option]:not(.is-unavailable)")?.click();
  };

  /* Tarjetas de la landing: toda la tarjeta lleva a la ficha, salvo si el usuario estaba deslizando el carrusel. */
  const setupCardLinks = () => {
    let start = null;
    document.addEventListener("pointerdown", (event) => {
      start = event.target instanceof Element && event.target.closest(".product-type-card")
        ? { x: event.clientX, y: event.clientY }
        : null;
    }, true);
    document.addEventListener("click", (event) => {
      const card = event.target instanceof Element ? event.target.closest(".product-type-card") : null;
      const link = card?.querySelector(".product-type-card__link");
      if (!card || !link) return;
      const dragged = start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10;
      start = null;
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.target.closest("a")) return;
      window.location.href = link.href;
    }, true);
  };

  /* Pack Newborn: tocar la imagen de un diseño pasa al siguiente disponible. */
  const setupBundleImageTap = () => {
    document.addEventListener("click", (event) => {
      const image = event.target instanceof Element ? event.target.closest("[data-bundle-image]") : null;
      if (!image) return;
      const select = document.querySelector(`[data-bundle-select="${image.dataset.bundleImage}"]`);
      if (!select || select.disabled) return;
      const options = [...select.options].filter((option) => option.value && !option.disabled);
      if (options.length < 2) return;
      const current = options.findIndex((option) => option.selected);
      select.value = options[(current + 1) % options.length].value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    });
  };

  const init = () => {
    document.querySelectorAll("[data-product-gallery]").forEach(setupSwipeGallery);
    document.querySelectorAll(".purchase-card").forEach(setupPurchaseCard);
    window.setTimeout(preferAvailableOption, 600);
    setupCardLinks();
    setupBundleImageTap();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
